import React, { useEffect, useRef } from "react";
import { isSet } from "../../../../Utils/CommonFunctions";
import FormInputFields from "../../../../Components/FormInputFields";
import { ErrorBlock } from "../../../../hoc/FormInput";
import {
  extractFieldValue,
  extractOptions,
  getOutputFieldsElement,
  injectVariableValues,
  isValidJson,
} from "../../MarkupFunctions";
import SwitchItems from "../../../FormBuilder/Builder/FormInputs/SwitchItems";
import PagesInputFields from "../../../PagesInputFields";
import ScmSubFormItem from "../ScmSubFormItem";
import ResourceInput from "./ResourceInput";

// GET FIELDS PROPS ELEMENT
const ScmInputTextField = ({ attributes, elmtParams }) => {
  const { defProps, children } = elmtParams;
  let dynamicVar = {
    ...elmtParams.dynamicVar,
    ...defProps.outputResponse,
  };
  const dataElmt = getOutputFieldsElement(attributes, elmtParams);

  let dataElmtStr;
  if (React.isValidElement(dataElmt)) {
    dataElmtStr = "";
  } else if (isValidJson(dataElmt)) {
    dataElmtStr = JSON.stringify(dataElmt);
  } else {
    dataElmtStr = dataElmt;
  }

  const hasLoadedPage = useRef(false);
  const attribsName = attributes.hasOwnProperty("name")
    ? attributes.name
    : "";
  const {
    modType,
    fieldGroups,
    formFields,
    isPreview,
    resourcesList,
    onChangeResourcesFieldHandler,
    fieldFormPayload,
    windowVariableList,
  } = defProps;
  let element = null;
  let updatedAttributes = { ...attributes };
  const rawDefaultValue = isSet(
    attributes?.value || attributes?.defaultvalue,
    ""
  );

  // Apply default value from dynamicVar once, when it's an expression like ${path.to.value}
  useEffect(() => {
    if (hasLoadedPage.current) return;
    if (!updatedAttributes?.name) return;
    if (typeof rawDefaultValue !== "string") return;
    if (
      rawDefaultValue.indexOf("${") === -1 ||
      rawDefaultValue.indexOf("}") === -1
    )
      return;

    hasLoadedPage.current = true;

    const cleanedPath = rawDefaultValue
      .trim()
      .replace(/^\$\{\s*/, "")
      .replace(/\}\s*$/, "")
      .toLowerCase();

    const updateDefaultValue = extractFieldValue(dynamicVar, cleanedPath);
    console.log(
      "updateDefaultValue",
      cleanedPath,
      updatedAttributes?.name,
      updateDefaultValue
    );
    onChangeResourcesFieldHandler(
      { api_name: updatedAttributes?.name },
      updateDefaultValue
    );
  }, [rawDefaultValue, dynamicVar, updatedAttributes?.name, onChangeResourcesFieldHandler]);

  if (isPreview === true) {
    element = (
      <FormInputFields
        {...attributes}
        type="TextInput"
        changeHandler={() => {}}
        value=""
      />
    );
  }

  const obj = extractFieldValue(dynamicVar, attribsName);

  // Check if this is a subform field and route to ScmSubFormItem
  if (isSet(obj, null) !== null && isSet(obj.is_subform_field, false) === true) {
    const subformvar = dynamicVar?.subformvar;

    if (
      subformvar &&
      subformvar.rowData &&
      subformvar.rowIndex !== undefined &&
      subformvar.section
    ) {
      const {
        rowData,
        rowIndex,
        subformIndex,
        section,
        pageType,
        isOpenBox,
        reminderDisplayText,
        onChangeInputAction,
        processFieldData,
      } = subformvar;

      const fieldInSection = obj;
      if (fieldInSection) {
        let processedData;
        if (processFieldData && typeof processFieldData === "function") {
          processedData = processFieldData(fieldInSection);
        } else {
          const columnIndex =
            rowData.subform_column_values?.findIndex(
              (column) => column.table_descriptor_id == fieldInSection.id
            ) ?? -1;

          let columnData = {};
          if (columnIndex !== -1) {
            columnData = rowData.subform_column_values[columnIndex];
          }

          processedData = {
            reminder: isSet(columnData.reminder, ""),
            files: isSet(columnData.files, ""),
            selectedValue: isSet(columnData.selected_value, ""),
            selected_value_text: isSet(columnData.selected_value_text, ""),
            selecteddpnm: isSet(columnData.dpnm, ""),
            overridden: isSet(columnData.overridden, false),
            currency_code: isSet(columnData.currency_code, "CAD"),
            options: isSet(columnData.options, fieldInSection.options),
            columnIndex: columnIndex,
          };
        }

        const subformValidation =
          subformvar.subformValidation ||
          elmtParams.defProps?.validationForms?.[modType] ||
          {};

        element = (
          <ScmSubFormItem
            item={fieldInSection}
            modType={modType}
            keyIndex={fieldInSection.id || attribsName}
            subFormIndex={subformIndex}
            columnIndex={processedData.columnIndex}
            rowIndex={rowIndex}
            pageType={pageType}
            subformValidation={subformValidation}
            reminderDisplayText={reminderDisplayText}
            rowId={rowData.id || ""}
            isOpenBox={isOpenBox}
            section={section}
            reminder={processedData.reminder}
            files={processedData.files}
            selectedValue={processedData.selectedValue}
            selected_value_text={processedData.selected_value_text}
            selecteddpnm={processedData.selecteddpnm}
            overridden={processedData.overridden}
            currency_code={processedData.currency_code}
            options={processedData.options}
            onChangeInputAction={
              fieldInSection?.onChangeInputAction || onChangeInputAction
            }
            elmtParams={elmtParams}
            defProps={defProps}
          />
        );

        return element;
      }
    }
  }

  fieldGroups.forEach((section) => {
    if (section.type !== "subform") {
      section.data.forEach((field, itemIndex) => {
        if (
          field.label?.blocks?.[0]?.text?.toLowerCase() ===
          attribsName.toLowerCase()
        ) {
          const fieldObj = {
            section_index: section.section_index,
            itemIndex: field.itemIndex,
            modType,
            item: {
              ...field,
              modType,
            },
          };

          let appendAttr = {};
          if (isSet(attributes.class, "") !== "") {
            appendAttr.className = isSet(attributes.class, "");
          }

          element = (
            <SwitchItems
              {...defProps}
              key={itemIndex}
              fieldObj={fieldObj}
              item={{
                ...field,
                displayType: isSet(attributes.displaytype, ""),
                customAttr: isSet(attributes, ""),
                modType,
              }}
              inputBlockOnly={true}
              onlyInputComponent={true}
              errorBlock={true}
              isLabel={
                isSet(attributes.withlabel, true) === "false"
                  ? false
                  : Boolean(isSet(attributes.withlabel, true))
              }
              withoutBlock={
                isSet(attributes.inputOnly, true) === "false"
                  ? false
                  : Boolean(isSet(attributes.inputOnly, true))
              }
              section={section}
              {...appendAttr}
            />
          );
        }
      });
    }
  });

  const indexing = formFields.findIndex(
    (i) => attribsName.toLowerCase() === i.label.toLowerCase()
  );
  if (indexing !== -1) {
    if (updatedAttributes.name) {
      delete updatedAttributes.name;
    }
    element = (
      <>
        <FormInputFields {...formFields[indexing]} {...updatedAttributes} />
        <ErrorBlock message={isSet(formFields[indexing].error, "")} />
      </>
    );
  }

  const resourcesIndexing = resourcesList.findIndex(
    (item) =>
      item.variable_name === attributes.name &&
      isSet(item.window_field_id_path, null) !== null
  );

  if (resourcesIndexing !== -1 && element === null) {
    const resource = resourcesList[resourcesIndexing];
    const currentWindowId = resource.window_id;
    const fieldPath = isSet(resource.window_field_id_path, null);
    const windowMeta = isSet(windowVariableList, {})[currentWindowId];

    const resourceElement = (
      <ResourceInput
        attributes={updatedAttributes}
        children={children}
        defProps={defProps}
        resource={resource}
        windowMeta={windowMeta}
        fieldPath={fieldPath}
        fieldFormPayload={fieldFormPayload}
        dataElmtStr={dataElmtStr}
      />
    );

    if (resourceElement) {
      element = resourceElement;
    }
  } else if (element === null && isSet(attributes.type, null) !== null) {
    if (
      attributes.type === "PickList" ||
      attributes.type === "Picklist" ||
      attributes.type === "MultiSelect"
    ) {
      const options = extractOptions(children, attributes.type);
      if (options.length > 0) {
        updatedAttributes = {
          ...updatedAttributes,
          options: options,
        };
      }
    }

    element = (
      <>
        <PagesInputFields
          {...updatedAttributes}
          childrenProps={children}
          value={
            fieldFormPayload[updatedAttributes.name]?.selected_value ||
            dataElmtStr
          }
          changeHandler={(value) =>
            onChangeResourcesFieldHandler(
              { api_name: updatedAttributes?.name },
              value
            )
          }
        />
      </>
    );
  }

  return element;
};

ScmInputTextField.defaultProps = {
  attributes: {},
  elmtParams: {},
};

export default ScmInputTextField;
